import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectFloorplans } from '../services/getProjectFloorplans.service';
import { getProjectFloorplanPlacements } from '../services/getProjectFloorplanPlacements.service';

export const loadProjectFloorplans = createAsyncThunk(
  'floorplans/loadProjectFloorplans',
  async (projectId) => {
    const [floorplansResponse, placementsResponse] = await Promise.all([
      getProjectFloorplans(projectId),
      getProjectFloorplanPlacements(projectId),
    ]);

    return {
      floorplans: floorplansResponse.floorplans || [],
      placements: placementsResponse.placements || [],
    };
  }
);
